var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppBar'),_c('div',[_c('v-container',{staticClass:"pa-0 px-0 pt-10 pt-md-14 ma-0 ma-lg-auto"},[_c('div',{staticClass:"body-part px-0 px-md-16 px-lg-0 pt-3"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }